// extracted by mini-css-extract-plugin
module.exports =  {"alert":"OBkh0IQTpsiTQOpPj5HA","cleanup":"izuFDSEHGfoi8U1RXxC9"};